import { Dispatch } from "redux";
import axios from "axios";

import {
  UPLOAD_BOOKING_AGREEMENT,
  UPLOAD_BOOKING_AGREEMENT_SUCCESS,
  UPLOAD_BOOKING_AGREEMENT_FAILURE,
  UPLOAD_BOOKING_LICENSE,
  UPLOAD_BOOKING_LICENSE_SUCCESS,
  UPLOAD_BOOKING_LICENSE_FAILURE,
  GET_BOOKING_CALCULATE_FAILURE,
  UPDATE_BOOKING_STATUS,
  UPDATE_BOOKING_STATUS_SUCCESS,
  UPDATE_BOOKING_STATUS_FAILURE,
  GET_ACTIVE_BOOKING_TYPES,
  GET_ACTIVE_BOOKING_TYPES_SUCCESS,
  GET_ACTIVE_BOOKING_TYPES_FAILURE,
  GET_BOOKING_CALCULATE,
  GET_BOOKING_STATUS,
  GET_ACTIVE_BOOKING,
  GET_ACTIVE_BOOKING_SUCCESS,
  GET_ALL_BOOKING,
  GET_ALL_BOOKING_SUCCESS,
  GET_BOOKING,
  GET_BOOKING_SUCCESS,
  GET_BOOKING_CALCULATE_SUCCESS,
  BOOKING_SUCCESS,
  BOOKING_FAILURE,
  ADD_BOOKING,
  GET_PENDING_BOOKING,
  GET_PENDING_BOOKING_SUCCESS,
  UPLOAD_BOOKING_SELFIE_WITH_CAR,
  UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS,
  UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE,
  UPLOAD_BOOKING_ADDRESS_PROOF,
  UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS,
  UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE,
  GET_FINAL_AGREEMENT_CHECKLIST,
  GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS,
  GET_FINAL_AGREEMENT_CHECKLIST_FAILURE,

  CANCEL_BOOKING, CANCEL_BOOKING_SUCCESS, CANCEL_BOOKING_FAILURE,
  GET_CHECKIN_IMAGE,
  GET_CHECKIN_IMAGE_SUCCESS,
  GET_CHECKIN_IMAGE_FAILURE,

  UPLOAD_CHECKIN_IMAGE,
  UPLOAD_CHECKIN_IMAGE_SUCCESS,
  UPLOAD_CHECKIN_IMAGE_FAILURE,

  GET_PROGRESS_MESSAGES,
  GET_PROGRESS_MESSAGES_SUCCESS,
  GET_PROGRESS_MESSAGES_FAILURE,

  CREATE_EXTENSION_REQUEST,
  CREATE_EXTENSION_REQUEST_SUCCESS,
  CREATE_EXTENSION_REQUEST_FAILURE,

  
  RESET_BOOKING_STATE,
  BookingActionTypes,
} from "../types/bookingTypes";


const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const getAllBooking =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_ALL_BOOKING, payload: [] });

      const response = await API.get("/bookings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: data,
      });

      if (response.status) {
        dispatch({ type: GET_ALL_BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getActiveBooking =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_ACTIVE_BOOKING, payload: [] });

      const response = await API.get("/bookings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: data,
      });

      if (response.status) {
        dispatch({ type: GET_ACTIVE_BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getPendingBooking =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_PENDING_BOOKING, payload: [] });

      const response = await API.get("/bookings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: data,
      });

      if (response.status) {
        dispatch({ type: GET_PENDING_BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getBooking =
  (id: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_BOOKING, payload: [] });

      const response = await API.get("/bookings/" + id, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({ type: GET_BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };


export const getBookingCalculate =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_BOOKING_CALCULATE, payload: [] });

      const response = await API.post("/bookings/calculate", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({
          type: GET_BOOKING_CALCULATE_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_BOOKING_CALCULATE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const addBooking =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: ADD_BOOKING, payload: [] });
      const response = await API.post("/bookings", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const updateBooking =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      const response = await API.put("/bookings", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({ type: BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const deleteBooking =
  () => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      const response = await API.delete("/bookings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({ type: BOOKING_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const updateBookingStatus =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: UPDATE_BOOKING_STATUS, payload: [] });
      const response = await API.post("/bookings/update/status", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({
          type: UPDATE_BOOKING_STATUS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: UPDATE_BOOKING_STATUS_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: UPDATE_BOOKING_STATUS_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };



export const cancelBooking = (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
  try {
    dispatch({ type: CANCEL_BOOKING, payload: [] });

    const response = await API.post("/bookings/update/status", data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });


    if (response.status === 200) {
      dispatch({ type: CANCEL_BOOKING_SUCCESS, payload: response.data });
    } else {
      // fallback for non-200 responses (very rare in Axios if no error thrown)
      dispatch({
        type: CANCEL_BOOKING_FAILURE,
        payload: response.data?.message || "Unexpected response",
      });
    }
  } catch (error: any) {

    let errorMessage = "Something went wrong";

    if (error.response) {
      if (error.response.status === 400) {
        errorMessage = error.response.data?.message || "Invalid request.";
      } else if (error.response.status === 401) {
        errorMessage = "Unauthorized. Please login again.";
      } else {
        errorMessage = error.response.data?.message || `Error: ${error.response?.status}`;
      }
    } else if (error.request) {
      errorMessage = "No response from server. Please check your connection.";
    } else {
      errorMessage = error.message;
    }


    dispatch({
      type: CANCEL_BOOKING_FAILURE,
      payload: errorMessage,
    });
  }
};



export const getBookingStatus =
  () => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      const response = await API.get("/bookingstatus", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({ type: GET_BOOKING_STATUS, payload: response.data });
      } else {
        dispatch({ type: BOOKING_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      dispatch({
        type: BOOKING_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getBookingTypes =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_ACTIVE_BOOKING_TYPES, payload: [] });

      const response = await API.get("/active-rental-types", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
          page: data?.page,
          itemsPerPage: data?.itemsPerPage,
        },
      });

      if (response.status) {
        dispatch({
          type: GET_ACTIVE_BOOKING_TYPES_SUCCESS,
          payload: response.data?.data,
        });
      } else {
        dispatch({
          type: GET_ACTIVE_BOOKING_TYPES_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_ACTIVE_BOOKING_TYPES_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const bookingLicenseUpload =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: UPLOAD_BOOKING_LICENSE, payload: [] });

      const response = await API.post("/bookings/documents/upload", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({
          type: UPLOAD_BOOKING_LICENSE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: UPLOAD_BOOKING_LICENSE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: UPLOAD_BOOKING_LICENSE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const uploadBookingAddressProof =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: UPLOAD_BOOKING_ADDRESS_PROOF, payload: [] });

      const response = await API.post("/bookings/address-proof/upload", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({
          type: UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const uploadBookingSelfieWithCar =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: UPLOAD_BOOKING_SELFIE_WITH_CAR, payload: [] });

      const response = await API.post(
        "/bookings/license-selfie-with-car/upload",
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (response.status) {
        dispatch({
          type: UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const uploadBookingAgreement =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: UPLOAD_BOOKING_AGREEMENT, payload: [] });

      const response = await API.post("/bookings/sign-agreement", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({
          type: UPLOAD_BOOKING_AGREEMENT_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: UPLOAD_BOOKING_AGREEMENT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
 
      dispatch({
        type: UPLOAD_BOOKING_AGREEMENT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

// export const getBookedDates = (vehicleId: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
//   try {
//     dispatch({ type: GET_BOOKING_DATES, payload: [] });

//     const response = await API.get(`/vehicles/${vehicleId}/booked-dates`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

//     if (response.status) {
//       dispatch({ type: GET_BOOKING_DATES_SUCCESS, payload: response.data?.data });
//     } else {
//       dispatch({ type: GET_BOOKING_DATES_FAILURE, payload: response.data.message });
//     }
//   } catch (error: any) {
//     dispatch({ type: GET_BOOKING_CALCULATE_FAILURE, payload: error?.response?.data?.message });
//   }
// };

export const getFinalAgreementChecklist =
  (bookings: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: GET_FINAL_AGREEMENT_CHECKLIST, payload: [] });

      const response = await API.get(
        `/bookings/${bookings?.bookingId}/final-agreement-checklist`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (response.status) {
        dispatch({
          type: GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS,
          payload: response.data?.data,
        });
      } else {
        dispatch({
          type: GET_FINAL_AGREEMENT_CHECKLIST_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_FINAL_AGREEMENT_CHECKLIST_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };




export const getCheckInImage =
  (bookings: any) => async (dispatch: Dispatch<BookingActionTypes>) => {

    try {
      dispatch({ type: GET_CHECKIN_IMAGE, payload: [] });

      const response = await API.get(`/checkin-images/${bookings?.bookingId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });



      if (response.status) {
        dispatch({
          type: GET_CHECKIN_IMAGE_SUCCESS,
          payload: response.data?.data,
        });
      } else {
        dispatch({
          type: GET_CHECKIN_IMAGE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_CHECKIN_IMAGE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };





export const uploadCheckInImage =
  (data: any) => async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: UPLOAD_CHECKIN_IMAGE, payload: [] });

      const response = await API.post("/checkin/upload-image", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({
          type: UPLOAD_CHECKIN_IMAGE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: UPLOAD_CHECKIN_IMAGE_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: UPLOAD_CHECKIN_IMAGE_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };





export const getProgressMessages = () => async (dispatch: Dispatch<BookingActionTypes>) => {

  try {
    dispatch({ type: GET_PROGRESS_MESSAGES, payload: [] });

    const response = await API.get(`/checkin/progress-messages`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });


    if (response.status) {
      dispatch({
        type: GET_PROGRESS_MESSAGES_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: GET_PROGRESS_MESSAGES_FAILURE,
        payload: response.data.message,
      });
    }
  } catch (error: any) {
    dispatch({
      type: GET_PROGRESS_MESSAGES_FAILURE,
      payload: error?.response?.data?.message,
    });
  }
};

export const createExtensionRequest =
  (data: { booking_id: number; requested_end_date: string; requested_end_time: string }) =>
  async (dispatch: Dispatch<BookingActionTypes>) => {
    try {
      dispatch({ type: CREATE_EXTENSION_REQUEST, payload: [] });

      const response = await API.post("/customer/extension-request", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status === 200) {
        dispatch({
          type: CREATE_EXTENSION_REQUEST_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: CREATE_EXTENSION_REQUEST_FAILURE,
          payload: response.data.message || "Failed to create extension request",
        });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      dispatch({
        type: CREATE_EXTENSION_REQUEST_FAILURE,
        payload: error?.response?.data?.message || "Something went wrong",
      });
    }
  };


export const resetBooking = () => (dispatch: Dispatch<BookingActionTypes>) => {
  dispatch({ type: RESET_BOOKING_STATE });
};


